var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow.isPOShow)?_c('div',[_vm._v("\n  这是第一页\n  "),_c('button',{staticClass:"btn",on:{"click":_vm.showNext}},[_vm._v("点击")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }